const ArrowUpRight = (props: React.SVGProps<SVGSVGElement>) => (
  <svg width='9' height='9' viewBox='0 0 9 9' fill='currentColor' {...props}>
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M9 0.375C9 0.167893 8.83211 0 8.625 0H4.125C3.91789 0 3.75 0.167893 3.75 0.375C3.75 0.582107 3.91789 0.75 4.125 0.75H7.71967L0.109835 8.35983C-0.0366116 8.50628 -0.0366116 8.74372 0.109835 8.89017C0.256282 9.03661 0.493718 9.03661 0.640165 8.89017L8.25 1.28033V4.875C8.25 5.08211 8.41789 5.25 8.625 5.25C8.83211 5.25 9 5.08211 9 4.875V0.375Z'
      fill='currentColor'
    />
  </svg>
);

export default ArrowUpRight;
